import { createAction } from '../../core/AppUtils';
import {  DocumentRepository } from '../../core/repository';

export const ModuleEvents = {
  GET_DOCUMENTLIST: "GET_DOCUMENTLIST",
  ADD_DOCUMENT:"ADD_DOCUMET",
  DELETE_DOCUMENT:"DELETE_DOCUMENT",
  DOCUMENT_STATUS_UPDATE:"DOCUMENT_STATUS_UPDATE",
  UPDATE_DOCUMENT:"UPDATE_DOCUMENT",
  CHECK_DOCUMENT_ASSOCIATION: "CHECK_DOCUMENT_ASSOCIATION",
  CREATE_FOLDER: "CREATE_FOLDER",
  SAVE_PAGE_NOTE: "SAVE_PAGE_NOTE",
  GET_PAGE_NOTE: "GET_PAGE_NOTE",
};

export default {
  // for getting documents by course
  getDocumentList: createAction(ModuleEvents.GET_DOCUMENTLIST, async (params) => {
    return await DocumentRepository.getDocumentList(params);
  }),

  addDocument: createAction(ModuleEvents.ADD_DOCUMENT, async (params) => {
    return await DocumentRepository.addDocument(params);
  }),

  deleteDocument: createAction(ModuleEvents.DELETE_DOCUMENT, async (params) => {
    return await DocumentRepository.deleteDocument(params);
  }),

  updateDocumentStatus:createAction(ModuleEvents.DOCUMENT_STATUS_UPDATE, async (params) => {
    return await DocumentRepository.updateDocumentStatus(params);
  }),

  updateDocument:createAction(ModuleEvents.UPDATE_DOCUMENT, async (params) => {
    return await DocumentRepository.updateDocument(params);
  }),

  createFolder: createAction(ModuleEvents.CREATE_FOLDER, async (params) => {
    return await DocumentRepository.createFolder(params);
  }),

  checkDocumentAssociation: createAction(ModuleEvents.CHECK_DOCUMENT_ASSOCIATION, async (documentId) => {
    return await DocumentRepository.checkDocumentAssociation(documentId);
  }),

  savePageNote: createAction(ModuleEvents.SAVE_PAGE_NOTE, async (params) => {
    return await DocumentRepository.savePageNote(params);
  }),

  getPageNote: createAction(ModuleEvents.GET_PAGE_NOTE, async (params) => {
    return await DocumentRepository.getPageNote(params);
  }),
};